module.exports = __webpack_public_path__ + "img/outofstock.bd9d5458.svg";